import IdeItem from './IdeItem'

import styles from './IdeList.module.css'

import EclipseIcon from './ide-icons/eclipse.svg'
import GitHubIcon from './ide-icons/github.svg'
import JetBrainsIcon from './ide-icons/jetbrains-logo.svg'
import RaycastIcon from './ide-icons/raycast-logo.svg'
import SqlServerManagementStudioIcon from './ide-icons/sql-server-management-studio-logo.svg'
import NeovimIcon from './ide-icons/neovim.svg'
import VisualStudioIcon from './ide-icons/visualstudio.webp'
import VSCodeIcon from './ide-icons/vscode.svg'
import XcodeIcon from './ide-icons/xcode.svg'
import ZedIcon from './ide-icons/zed.svg'
import {isFeatureEnabled} from '@github-ui/feature-flags'

interface IdeListProps {
  location: string
  type: 'big' | 'small'
}

export default function IdeList({location, type = 'big'}: IdeListProps) {
  const IdeData = [
    {
      title: 'GitHub',
      href: 'https://github.com/copilot',
      image: GitHubIcon,
      action: 'github',
      location,
    },
    {
      title: 'VS Code',
      href: 'https://marketplace.visualstudio.com/items?itemName=GitHub.copilot-chat',
      image: VSCodeIcon,
      action: 'vscode',
      location,
    },
    {
      title: 'Visual Studio',
      href: 'https://visualstudio.microsoft.com/github-copilot',
      image: VisualStudioIcon,
      action: 'vs',
      location,
    },
    {
      title: 'Xcode',
      href: 'https://github.com/github/CopilotForXcode',
      image: XcodeIcon,
      action: 'xcode',
      location,
    },
    {
      title: 'JetBrains',
      appendix: 'IDEs',
      href: 'https://plugins.jetbrains.com/plugin/17718-github-copilot',
      image: JetBrainsIcon,
      action: 'jetbrains',
      location,
    },
    {
      title: 'Neovim',
      href: 'https://github.com/github/copilot.vim',
      image: NeovimIcon,
      action: 'neovim',
      location,
    },
    {
      title: 'Eclipse',
      href: 'https://marketplace.eclipse.org/content/github-copilot#details',
      image: EclipseIcon,
      action: 'eclipse',
      location,
    },
    {
      title: 'Raycast',
      href: 'https://gh.io/copilot-raycast-docs',
      image: RaycastIcon,
      action: 'raycast',
      location,
    },
    ...(isFeatureEnabled('copilot_features_sql_server_logo')
      ? [
          {
            title: 'SQL Server',
            appendix: 'Management Studio',
            href: 'https://learn.microsoft.com/ssms/github-copilot/get-started',
            image: SqlServerManagementStudioIcon,
            action: 'sqlservermanagementstudio',
            location,
          },
        ]
      : []),
    {
      title: 'Zed',
      href: 'https://zed.dev/acp/agent/github-copilot',
      image: ZedIcon,
      action: 'zed',
      location,
    },
  ]

  return (
    <ul className={`${styles.list}${type === 'small' ? ` ${styles.small}` : ''}`}>
      {IdeData.map(ide => (
        <IdeItem
          key={ide.action}
          href={ide.href}
          image={ide.image}
          action={ide.action}
          location={ide.location}
          text={ide.title}
          appendix={ide.appendix}
        />
      ))}
    </ul>
  )
}
